import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const EMAIL_REGEX = '^[A-Za-z0-9!#$%&’*+/=?^\\-_‘{|}~.]+@[A-Za-z0-9]+(\\.[A-Za-z]{2,})+$';
export const DELOITTE_REGEX = '^[A-Za-z0-9!#$%&’*+/=?^\\-_‘{|}~.]+@deloitte+(\\.[A-Za-z]{2,})+$';
export const PASSWORD_REGEX = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+{}\\[\\]:;<>,.?\\/\\\\|~])[\\S]{8,}$';

// FOR INPUT PATTERN DIRECTIVE
export const NAME_REGEX = /^[ a-zA-Z'-]+$/;
export const PASTE_NAME_REGEX = /[^a-zA-Z'-]+$/g;
export const EMAIL_INPUT_REGEX = /\S+$/;
export const PASTE_EMAIL_REGEX = /[ ]*/g;
export const VALIDATION_CODE_REGEX = /^[0-9]+$/;
export const PASTE_CODE_REGEX = /[^0-9]/g;

export const DELOITTE_STR = '@deloitte.';

export function forgotPasswordDeloitte(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value as string;
  if (value && value.toLowerCase().includes('@deloitte.')) {
    return { forgotPasswordDeloitte: true };
  }
  return null;
}

export function passwordFormat(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value as string;
  const regexp = new RegExp(PASSWORD_REGEX, 'i');
  if (value && !regexp.test(value)) {
    return { passwordFormat: true };
  }
  return null;
}

export function emailFormat(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value as string;
  const regexp = new RegExp(EMAIL_REGEX, 'i');
  if (value && !regexp.test(value)) {
    return { emailFormat: true };
  }
  return null;
}

export function nonDeloitteEmail(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value as string;
  const regexp = new RegExp(DELOITTE_REGEX, 'i');
  if (value && regexp.test(value)) {
    return { nonDeloitteEmail: true };
  }
  return null;
}

export function notEmpty(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value as string;
  const regex = /^\s+$/;
  if (value && regex.test(value)) {
    return { isEmpty: true };
  }
  return null;
}

export function matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (abstractControl: AbstractControl) => {
    const control = abstractControl.get(controlName);
    const matchingControl = abstractControl.get(matchingControlName);

    if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
      return null;
    }

    if (control!.value !== matchingControl!.value) {
      const error = { confirmedValidator: 'Passwords do not match.' };
      matchingControl!.setErrors(error);
      return error;
    } else {
      matchingControl!.setErrors(null);
      return null;
    }
  };
}
